import script from "./Dtable.vue?vue&type=script&setup=true&lang=js"
export * from "./Dtable.vue?vue&type=script&setup=true&lang=js"

import "./Dtable.vue?vue&type=style&index=0&id=7f7d99de&lang=css"

const __exports__ = script;

export default __exports__